import { Box, Typography } from "@mui/material";
import UnderlineButton from "../buttons/underlineButton.component";

const InfoBox = ({
  theme,
  label,
  buttonLabel,
  onClick,
  actions = true,
  data,
}) => {
  return (
    <Box
      width="100%"
      height="40px"
      sx={{
        backgroundColor: theme?.palette?.custom?.backgroundColor,
        borderRadius: "2px",
      }}
      p={1}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography fontWeight="bold" fontSize="14px">
        {label}
      </Typography>
      {actions ? (
        <UnderlineButton onClick={onClick} label={buttonLabel} />
      ) : (
        <Typography fontWeight="bold" fontSize="14px">
          {data}
        </Typography>
      )}
    </Box>
  );
};

export default InfoBox;
